import { ToolPageShell } from '@/shared/seo'
import { SnyatParolSPdfForm } from './SnyatParolSPdfForm'

export function SnyatParolSPdfPage() {
  return (
    <ToolPageShell utilityKey="unlockPdf">
      <SnyatParolSPdfForm />
    </ToolPageShell>
  )
}
